import config from '@/config'
import Groups from '@/models/Groups'
import { IMembership } from '@/models/Learning'
import { PaginationParams } from '@/types/PaginationParams'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)
export default class CoursesService extends BaseService<Groups> {
  protected basePath = ''

  private groupEndpointBasePath: string

  model(): typeof Groups {
    return Groups
  }

  constructor(locationId: string, groupId: string) {
    super(locationId)
    this.basePath = `/${locationId}`
    this.groupEndpointBasePath = `${this.basePath}/groups/${groupId}`
  }

  async getUserCourses(paginationObject?: PaginationParams): Promise<any> {
    const response = await http.get(
      `${this.groupEndpointBasePath}/user/courses`,
      {
        params: paginationObject,
      }
    )
    return response?.data
  }

  async getGroupCourses(paginationObject?: PaginationParams): Promise<any> {
    const response = await http.get(`${this.groupEndpointBasePath}/courses`, {
      params: paginationObject,
    })
    return response.data
  }

  async getGroupCourse(productId: string): Promise<any> {
    const response = await http.get(
      `${this.groupEndpointBasePath}/courses/${productId}`
    )
    return response.data
  }

  async getAllLocationCourses(
    paginationObject?: PaginationParams
  ): Promise<any> {
    const response = await http.get(`${this.endpoint}/courses`, {
      params: paginationObject,
    })
    return response.data
  }

  async addCourseToGroup(
    productId: string,
    productName: string,
    membership?: IMembership
  ): Promise<any> {
    const response = await http.post(`${this.groupEndpointBasePath}/courses`, {
      productId,
      productName,
      membership,
    })
    return response.data
  }

  async updateCourseFromGroup(
    offerId: string,
    productName: string,
    membership?: IMembership
  ): Promise<any> {
    const response = await http.patch(
      `${this.groupEndpointBasePath}/courses/${offerId}`,
      {
        membership,
        productName,
      }
    )
    return response.data
  }

  async purchaseCourse(offerId: string): Promise<any> {
    const response = await http.post(
      `${this.groupEndpointBasePath}/courses/purchase`,
      {
        offerId,
      }
    )
    return response.data
  }

  async deleteCourseFromGroup(productId: string): Promise<any> {
    const response = await http.delete(
      `${this.groupEndpointBasePath}/courses/${productId}`
    )
    return response.data
  }

  async rearrangeCourses(
    movedProductId: string,
    previousProductId?: string,
    nextProductId?: string
  ): Promise<any> {
    const response = await http.patch(
      `${this.groupEndpointBasePath}/rearrange/courses/${movedProductId}`,
      undefined,
      {
        params: {
          previousProductId,
          nextProductId,
        },
      }
    )
    return response.data
  }
}
